module.exports = __webpack_public_path__ + "img/icon-empty-lable.8b85968a.png";